import { createApp } from 'vue';
import SvgIcon from '@/components/SvgIcon'; // svg component

// register globally - this will be done in main.js
// Vue 3 component registration should happen in main.js

const req = require.context('./svg', false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);

export { SvgIcon };
